/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import { Box } from "@chakra-ui/react";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import dashRoutes from "routes/dashRoutes";
import SignIn from "views/Login/SignIn";   // ✅ SignIn doğru import

export default function Pages(props) {
  const wrapper = React.createRef();

  React.useEffect(() => {
    document.body.style.overflow = "unset";
    return function cleanup() {};
  }, []);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.category === "account") {
        return getRoutes(prop.views);
      }
      // ❌ Burada /auth route aramaya gerek yok
      return null;
    });
  };

  const navRef = React.useRef();
  document.documentElement.dir = "ltr";

  return (
    <Box ref={navRef} w="100%">
      <Box w="100%">
        <Box ref={wrapper} w="100%">
          <Switch>
            {/* sadece admin rotaları getRoutes’tan geliyor */}
            {getRoutes(dashRoutes)}

            {/* ✅ Login route manuel tanımlı */}
            <Route exact path="/login" component={SignIn} />

            {/* 🚨 fallback redirect */}
            <Redirect exact from="/auth" to="/login" />
          </Switch>
        </Box>
      </Box>
    </Box>
  );
}
